import React, { useState } from 'react'
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AiOutlinePlus } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";
import { AiOutlineArrowUp } from "react-icons/ai";
import { BsTable } from "react-icons/bs";

import "./FloatingButton.css"

import company_register_icon from "../../images/FAB_Icons/check_white.png";
import visitor_register_icon from "../../images/FAB_Icons/ticket_white.png"
import about_schedule_icon from "../../images/FAB_Icons/schedule_white.png"

const FloatingButton = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const hrefTo = location["pathname"] === "/" ? "/#first" : "javascript:void(0)"
//   const hrefConfig = location["pathname"] === "/" ? {} : {pointerEvents:"none"}

  const scrollToTop = (beh) =>{
    window.scrollTo({
        top: 0, 
        behavior: beh
    });
  };

  return (
  <div>
    <div class="square-container hidden md:flex">
      <ul className="options">
        <li>
            <Link to="/visitor/registration" onClick={() => scrollToTop("auto")}>
                <div class="icon-squarebutton">
                    <img src={visitor_register_icon} className="" />
                    <p className='icon-desc'>{t("floating_but1")}</p>
                </div>
            </Link>
        </li>
        <li>
            <Link to="/exhibitor/overview" onClick={() => scrollToTop("auto")}>
                <div class="icon-squarebutton">
                    <img src={company_register_icon} className="" />
                    <p className='icon-desc'>{t("floating_but2")}</p>
                </div>
            </Link>
        </li>
        <li>
            <Link to="/about/schedule" onClick={() => scrollToTop("auto")}>
                <div class="icon-squarebutton">
                    <img src={about_schedule_icon} className="" />
                    {/* <BsTable className='float-square-i' /> */}
                    <p className='icon-desc'>{t("floating_but3")}</p>
                </div>
            </Link>
        </li>
      </ul>
    </div>
    <div class="fab-container">
      {/*<div class="button iconbutton" onClick={() => setOpen(!open)}>
        {!open ? <AiOutlinePlus className="float-i" /> : <AiOutlineClose className='float-i' /> }
    </div>*/}
      <ul className="options">
        <li>
        <a href={hrefTo}>
          <div class="iconbutton button" onClick={() => scrollToTop("smooth")}>
            <AiOutlineArrowUp className='float-i' />
          </div>
        </a>
        </li>
      </ul>
    </div>
  </div>
  )
}

export default FloatingButton